
export default {
  code: "lt",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: "Atgal",
    next: "Pirmyn",
    today: "Šiandien",
    month: "Mėnuo",
    week: "Savaitė",
    day: "Diena",
    list: "Darbotvarkė"
  },
  weekLabel: "SAV",
  allDayText: "Visą dieną",
  eventLimitText: "daugiau",
  noEventsMessage: "Nėra įvykių rodyti"
};
